export default {
  Confirm: '確定',
  Cancel: '取消',
  'The minimum time length is xxxs!': '最小時長為{{num}}s！',
  'The maximum time length is 50s!': '最大時長為50s！',
  'Online service, no download required': '線上編輯，無需下載',
  'Add up to 20MB file': '檔案大小上限為20MB',
  'Support common formats': '支持流行格式',
  'Best for general editing requirements': '解決你的日常編輯需求',
  '0 second wait': '0秒等待',
  'No size limits': '沒有檔案大小限制',
  'Support 1000+ formats': '支持1000多種格式',
  'Stable processing': '處理穩定',
  'Get access to HitPaw Toolkit!': '查看HitPaw Toolkit！',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    '提供截取、旋轉&翻轉、調色、變速、加音樂等功能',
  'The easiest video editing software for beginners': '最適合初學者的編輯軟體',
  'Remove watermark from videos and images in simple clicks':
    '只需簡單點擊幾下，即可從影片和圖像中刪除浮水印',
  'TRY IT FREE': '免費嘗試',
  'BUY NOW': '立即購買',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    '影片解析成功！但是目前暫不支援處理大小超過100MB的文件，請',
  'download the video': '下載影片',
  'and then use HitPaw Toolkit to proceed.': '後用Toolkit進行處理。',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    '最多截取10個片段。下載 HitPaw Toolkit 獲取更多功能。',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    '最大支持20MB的文件。下載 HitPaw Toolkit 獲取更多功能。',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    '最小時長為1s！下載 HitPaw Toolkit 獲取更多功能。',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    '最多添加3個視頻。下載 HitPaw Toolkit 獲取更多功能。',
  'This format is not supported currently.': '暫不支持該格式。',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    '暫不支持該格式。下載 HitPaw Toolkit 獲取更多功能。',
  'Processing failed. Get HitPaw Toolkit for stable processing.': '生成視頻失敗！',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.': '加載失敗！',
  'Are you sure you want to delete it?': '您確定要刪除嗎？',
  'Failed to extract the audio!': '無法提取音頻！',
  'Coming Soon': '即將到來',
  'Learn more': '了解更多',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    '最多添加2個檔案。 下載 HitPaw Toolkit 獲取更多功能。',
  Download: '下載',
  'Try Again': '再試一次',
  Failed: '失敗',
  'Get Started': '開始編輯',
  Start: '開始',
  End: '結束',
  Export: '導出',
  'Your audio is ready!': '你的音訊已經準備好了',
  'Download Audio': '下載音訊',
  YES: '是的',
  'Export Failed': '輸出失敗',
  'Error occurs, the file cannot be added': '檔案無法添加，添加失敗',
  'Support merging audio files at most': '最多支持合併{{num}}個音訊檔案',
  'Are you sure you want to delete this task?': '是否確認刪除任務',
  Processing: '正在處理',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    '不要忘記下載你的檔案，它將在24小時後被刪除',
  Uploading: '上傳中',
  'Go Edit': '去編輯',
  'Generate Files Successfully!': '生成文件成功！',
  'Your order is being paid...': '您的訂單正在支付中',
  'Not yet': '还没有',
  'Payment completed': '付款完成',
  downloadFail: 'Failed to download, please try again.',
  videoReady: 'Your animated photo is ready!',
  'Download Without Watermark': 'Download Without Watermark',
  'Download As GIF': 'Download As GIF',
  'Download With Watermark': 'Download With Watermark',
  'Upload New Photo': 'Upload New Photo',
  ///////////
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 20MB. Download HitPaw Video Converter for more features.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 500MB. Download HitPaw Video Converter for more features.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'The uploaded image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
  'Download desktop version to batch process large files with no size limit': 'Download desktop version to batch process large files with no size limit',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Convert Apple Music to MP3 with DRM removed (Windows version only)',
} 
